import React from 'react';
import { motion } from 'framer-motion';
export function EmotionalSection() {
  return <section className="py-8 bg-[#FAFAF8]" data-id="element-47">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-48">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-6" data-id="element-49">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a1a2e] mb-3 font-montserrat" data-id="element-50">
            Si esto te resulta familiar, no estás sola
          </h2>
          <div className="w-24 h-1 bg-[#F97316] mx-auto rounded-full" data-id="element-51" />
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="space-y-3 text-lg text-gray-700 leading-relaxed font-lato" data-id="element-52">
          <p data-id="element-53">
            Muchas madres sienten que la tecnología ocupa cada vez más espacio
            en casa.
          </p>
          <p data-id="element-54">
            Las conversaciones se interrumpen. Las comidas se vuelven
            silenciosas. Y el celular parece competir con la conexión familiar.
          </p>
          <div className="bg-white p-4 rounded-xl shadow-sm border-l-4 border-[#0ABFBC] my-4" data-id="element-55">
            <p className="font-medium text-[#1a1a2e] italic" data-id="element-56">
              "No es falta de amor. No es falta de autoridad."
            </p>
          </div>
          <p data-id="element-57">
            Es que las plataformas digitales están diseñadas para captar
            atención constantemente.
          </p>
          <p className="font-semibold text-[#1a1a2e]" data-id="element-58">
            Sin una estrategia clara, la dinámica familiar puede perder
            equilibrio.
          </p>
        </motion.div>
      </div>
    </section>;
}